// components/CoberturaModal.jsx
import React, { useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, FormGroup, Label, Button } from 'reactstrap';
import Select from 'react-select';
import { calcTasa } from './utils/planesUtils';

const CoberturaModal = ({
  isOpen,
  toggle,
  isEdit,
  nuevaCobertura,
  setNuevaCobertura,
  coberturasOptions,
  coberturasLoading,
  coberturasError,
  onGuardar,
  setCoberturasError,
  erroresValidacion,
  deduciblesOptions,
  modoManual,
  soloLectura = false,
  onCoberturaSeleccionada,
  primaHabilitada = true,
  sumaHabilitada = true,
  coberturaPuedeSeleccionarDeducibleHabilitada = true,
  parametrizacionLoading = false
}) => {
  // value actual del select (encuentra opción por cod_riesgo)
  const selectedCobertura = useMemo(function () {
    const list = coberturasOptions || [];
    const code = nuevaCobertura && nuevaCobertura.cod_riesgo ? String(nuevaCobertura.cod_riesgo) : '';
    for (var i = 0; i < list.length; i++) {
      var v = list[i] && list[i].value ? String(list[i].value) : '';
      if (v === code) return list[i];
    }
    return null;
  }, [coberturasOptions, nuevaCobertura]);

  const handleSelectCobertura = function (opt) {
    // opt puede ser null si limpiaron el select
    if (!opt) {
      setNuevaCobertura({
        cod_riesgo: '',
        nombre: '',
        sumaAsegurada: '',
        tasa: '',
        prima: '',
        deducible: 'SIN DEDUCIBLE',
        cod_deducible: '2'
      });
      setCoberturasError('');
      return;
    }

    var full = opt && opt.raw ? opt.raw : {
      cod_riesgo: opt && opt.value != null ? String(opt.value) : '',
      Cobertura: opt && opt.label != null ? String(opt.label) : ''
    };

    if (full && full.Cobertura != null && full.nombre == null) {
      full.nombre = String(full.Cobertura);
    }
    if (full && full.cod_riesgo != null) {
      full.cod_riesgo = String(full.cod_riesgo);
    }

    var ded = (full && full.deducible !== undefined && full.deducible !== null)
      ? full.deducible
      : 'SIN DEDUCIBLE';
    var codDed = (full && full.cod_deducible !== undefined && full.cod_deducible !== null)
      ? full.cod_deducible
      : (full && full.dedCodigoCore !== undefined && full.dedCodigoCore !== null ? String(full.dedCodigoCore) : '2');

    setNuevaCobertura(function (prev) {
      var merged = {};
      for (var k in prev) { merged[k] = prev[k]; }
      for (var k2 in full) { merged[k2] = full[k2]; }
      merged.cod_riesgo = full.cod_riesgo || '';
      merged.nombre = full.nombre || (full.Cobertura ? String(full.Cobertura) : '');
      merged.deducible = ded;
      merged.cod_deducible = codDed;
      merged._raw = full;
      return merged;
    });

    setCoberturasError('');

    if (onCoberturaSeleccionada) onCoberturaSeleccionada(full);
  };

  const tasaDisplay = useMemo(() => {
    const calculated = calcTasa(
      nuevaCobertura && nuevaCobertura.prima,
      nuevaCobertura && nuevaCobertura.sumaAsegurada
    );
    const t = calculated || (nuevaCobertura && nuevaCobertura.tasa != null ? String(nuevaCobertura.tasa) : '');
    if (!t) return '';
    const num = Number(t);
    if (isNaN(num)) return t;
    return num.toFixed(4).replace(/\.?0+$/, '');
  }, [nuevaCobertura]);

  const handleChangeCobertura = (field) => (e) => {
    let val = e.target.value;

    // Evitar magnitud desbordada (máximo 8 dígitos enteros)
    if (val) {
      const parts = val.split('.');
      if (parts[0].length > 8) {
        parts[0] = parts[0].slice(0, 8);
        val = parts.join('.');
      }
    }

    setNuevaCobertura(function (prev) {
      var next = {};
      for (var k in prev) { next[k] = prev[k]; }
      if (field === 'deducible') {
        const opt = (deduciblesOptions || []).find(o => String(o.value) === String(val));
        if (opt && opt.raw) {
          next.deducible = opt.raw.dedDescripcion || opt.raw.dedNombre || '';
          next.cod_deducible = String(opt.raw.dedCodigoCore);
        } else {
          next.deducible = val;
          next.cod_deducible = val === 'SIN DEDUCIBLE' ? '2' : '';
        }
      } else {
        next[field] = val;
      }
      next.tasa = calcTasa(next.prima, next.sumaAsegurada);
      return next;
    });
  };

  // estilos para que el menú flote sobre modales/overlays
  const selectStyles = {
    menuPortal: function (base) { return Object.assign({}, base, { zIndex: 9999 }); },
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {soloLectura ? 'Ver cobertura' : isEdit ? 'Editar cobertura' : 'Agregar cobertura'}
      </ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label>Cobertura</Label>

          {soloLectura ? (
            <Input
              type="text"
              value={nuevaCobertura && nuevaCobertura.nombre ? nuevaCobertura.nombre : ''}
              readOnly
              disabled
            />
          ) : (
            <Select
              value={selectedCobertura}
              onChange={handleSelectCobertura}
              options={coberturasOptions || []}
              isLoading={!!coberturasLoading}
              isDisabled={isEdit || !!coberturasLoading || !((coberturasOptions || []).length)}
              isClearable={!isEdit}
              isSearchable
              placeholder={coberturasLoading ? 'Cargando coberturas...' : 'Seleccione una cobertura de la lista'}
              noOptionsMessage={function () { return coberturasLoading ? 'Cargando…' : 'Sin resultados'; }}
              menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
              styles={selectStyles}
            />
          )}

          {coberturasError && typeof coberturasError === 'string' && <small style={{ color: 'red' }}>{coberturasError}</small>}
          {erroresValidacion && erroresValidacion.cobertura && <small className="d-block mt-1" style={{ color: '#dc3545', fontSize: '13px' }}>{erroresValidacion.cobertura}</small>}
          {erroresValidacion && erroresValidacion.global && <small className="d-block mt-1" style={{ color: '#dc3545', fontSize: '13px' }}>{erroresValidacion.global}</small>}
        </FormGroup>

        <FormGroup>
          <Label>Deducible</Label>
          <Input
            type="select"
            value={(nuevaCobertura && nuevaCobertura.cod_deducible !== undefined && nuevaCobertura.cod_deducible !== null && nuevaCobertura.cod_deducible !== "")
              ? nuevaCobertura.cod_deducible
              : '2'}
            onChange={handleChangeCobertura('deducible')}
            disabled={!coberturaPuedeSeleccionarDeducibleHabilitada}
             style={{
                      backgroundColor: !coberturaPuedeSeleccionarDeducibleHabilitada
                        ? "#e9ecef"
                        : "#fff",
                      color: !coberturaPuedeSeleccionarDeducibleHabilitada
                        ? "#6c757d"
                        : "#212529",
                      opacity: 1,
                      cursor: !coberturaPuedeSeleccionarDeducibleHabilitada
                        ? "not-allowed"
                        : "pointer",
                      borderColor: !coberturaPuedeSeleccionarDeducibleHabilitada
                        ? "#ced4da"
                        : ""
                    }}
          >
            {deduciblesOptions && deduciblesOptions.length > 0 ? (
              deduciblesOptions.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))
            ) : (
              <option value="2">2 - SIN DEDUCIBLE</option>
            )}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label>Suma asegurada</Label>
          <Input
            type="number"
            step="0.01"
            value={nuevaCobertura && nuevaCobertura.sumaAsegurada ? nuevaCobertura.sumaAsegurada : ''}
            onChange={handleChangeCobertura('sumaAsegurada')}
            placeholder="Ej: 50000"
            min="0.01"
            invalid={!!(erroresValidacion && erroresValidacion.sumaAsegurada)}
            readOnly={soloLectura || !sumaHabilitada}
            disabled={soloLectura || !sumaHabilitada || parametrizacionLoading}
          />
          {erroresValidacion && erroresValidacion.sumaAsegurada && <small className="d-block" style={{ color: '#dc3545', fontSize: '13px' }}>{erroresValidacion.sumaAsegurada}</small>}
        </FormGroup>

        <FormGroup>
          <Label>Prima neta anual</Label>
          <Input
            type="number"
            step="0.01"
            value={nuevaCobertura && nuevaCobertura.prima ? nuevaCobertura.prima : ''}
            onChange={handleChangeCobertura('prima')}
            placeholder="Ej: 120.50"
            min="0.01"
            invalid={!!(erroresValidacion && erroresValidacion.prima)}
            readOnly={soloLectura || !primaHabilitada}
            disabled={soloLectura || !primaHabilitada || parametrizacionLoading}
          />
          {erroresValidacion && erroresValidacion.prima && <small className="d-block" style={{ color: '#dc3545', fontSize: '13px' }}>{erroresValidacion.prima}</small>}
        </FormGroup>

        <FormGroup>
          <Label>Tasa comercial (%)</Label>
          <Input
            type="number"
            step="0.01"
            value={tasaDisplay}
            readOnly
            disabled
            placeholder="Se calcula automáticamente"
          />
          <small className="text-muted">Fórmula: (Prima neta / Suma asegurada) * 1000</small>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        {soloLectura ? (
          <>
            <Button color="primary" onClick={onGuardar}>
              Guardar cambios
            </Button>
          {' '}
          <Button color="secondary" onClick={toggle}>Cerrar</Button>
        </>
          
        ) : (
          <>
            <Button color="primary" onClick={onGuardar}>
              {isEdit ? 'Guardar cambios' : 'Agregar'}
            </Button>{' '}
            <Button color="secondary" onClick={toggle}>Cancelar</Button>
          </>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default CoberturaModal;
